module.exports = __webpack_public_path__ + "static/media/blockcube.227fce38.png";